export default {"src":"/_next/static/media/ORCL.b68b93bf.svg","height":18,"width":18};